/**
 * api/journey.js — estado da Jornada de um projeto (Bloco 0).
 *
 * GET /projects/{id}/journey → 6 fases (done/current/locked), 5 Quality Gates
 * (status real de Negócio/Squads; Tecnologia/Escopo/Final = nao_implementado até
 * os Blocos 2/4/5) e eventos de auditoria imutáveis. Alimenta a tela Gestão do
 * Projeto (hub).
 */
import { useQuery } from '@tanstack/react-query';
import { useApi } from './client';

export function useProjectJourney(projectId, { refetchInterval } = {}) {
  const api = useApi();
  return useQuery({
    queryKey: ['project', projectId, 'journey'],
    queryFn:  () => api.get(`/projects/${projectId}/journey`),
    enabled:  Boolean(projectId),
    // Live Board passa refetchInterval para acompanhar os 5 gates ao vivo.
    ...(refetchInterval ? { refetchInterval } : {}),
  });
}
